// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"S5-z"};